module.exports = __webpack_public_path__ + "img/thckxx.6334e64f.png";